import "./App.css";
import Emojizzz from "./Emojizzz";

function App() {
  return (
    <div className="App">
      <Emojizzz />
    </div>
  );
}

export default App;
